import { SearchFilter as SearchFilterComponent } from './SearchFilter.component';
import { connector } from './SearchFilter.connector';

export const SearchFilter = connector(SearchFilterComponent);
